module.exports = __webpack_public_path__ + "img/20190801163518064.251a4cd4.png";